import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useClient } from '../../client-api';
import { type SettingsUpdateDto, updateInternalItemSettings, type UpdateSettingsResponseDto } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export const useUpdateProjectionInternalAssetItemSetting = (): UseMutationResult<UpdateSettingsResponseDto, AxiosError, SettingsUpdateDto> => {
    const queryClient = useQueryClient();
    const { data: client } = useClient();

    return useMutation({
        mutationFn: (payload) => updateInternalItemSettings({ body: payload, path: { id: payload.id! } }).then((result) => result.data!),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.saeInternalAssetSettings(client?.partnerUuid) });
            queryClient.invalidateQueries({ queryKey: queryKeys.projection(client?.partnerUuid) });
        },
    });
};
